import axios from "axios";
import AxiosClient from "../../services/axios.services";

class PositionHistoryServices {
  
  getPositionHistory = data =>
    AxiosClient.get(`/api/app/Funcional_historial_puestos_empleado/`, {
      headers: { "Content-Type": "application/json" },
      params: data,
    });
  
  
}

export default new PositionHistoryServices();